import { Input } from '@/components/Input';
import { selectAnnualKms, setAnnualKms } from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { getNumber } from '@/utils/valueFormat';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'AnnualKms';

export function AnnualKms({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    const currentState = useAppSelector(selectAnnualKms);
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean): void {
        const MAXIMUM = 1000000;
        const intValue = getNumber(value, MAXIMUM);
        if (intValue === currentState) return;
        dispatch(setAnnualKms(intValue));
    }

    function getValue(): string | undefined {
        return currentState?.toLocaleString();
    }

    function getPlaceholder(): string {
        return 'Enter';
    }

    // ***** Render *****
    return (
        <div data-testid={testId} className='w-full'>
            <Input
                title='How many kilometres do you drive annually?'
                placeholder='15,000'
                showErrors={showErrors && !currentState}
                message='Please enter how far you drive each year.'
                onChange={handleChange}
                id={`${baseId}-input-annualKms`}
                value={getValue()}
                showNumpad={true}
            />
        </div>
    );
}
